import {BLOCKS, INLINES} from "@contentful/rich-text-types";
import * as React from "react";
import Marquee from "react-fast-marquee";
import {useDispatch} from "react-redux";
import {Link} from "react-router-dom";
import {HeroBannerTwoColumns, ImageObject, StyledText, StyledTextVideo} from "../../contenful/types";
import {PATH} from "../../onboardingpage/modalview/UserModalController";
import {showCashier} from "../../payments/DepositActions";
import {CashierSection} from "../../payments/PaymentsReducer";
import {openFreshChat} from "../../ui/FreshChatWidget";
import {StyledTextVideoComponent} from "./StyledTextListComponent";
import "./styles/HeroBannerTwoColumns.scss";
import {CasinoGameInfo} from "../../http/protocol";
import {prettyUrl} from "../../utils/UrlUtils";
import {renderContentAsComponent} from "../../contentutils";
import { PopupStatus } from "../../popup/PopupReducer";
import { setPopupStatus } from "../../popup/PopupActions";
import { isIOS } from "react-device-detect";
import { showNativeAppInstallPrompt } from "../../ui/AppInstallComponent";
import { Dispatch } from "redux";


interface Props {
    section : HeroBannerTwoColumns;
    mobile : boolean;
    loggedIn? : boolean;
    isFooter? : boolean;
}


export function toLaunchUrl(gameId: string | number | undefined, name: string | undefined) {
    return `/casino/play/${gameId ?? ""}/${prettyUrl(`${name ? name : ''}`)}/auto`;
}

const onAppInstall = (dispatch: Dispatch): void => {
    if(isIOS) {
        dispatch(setPopupStatus(PopupStatus.APP_INSTALL));
    } else {
        showNativeAppInstallPrompt();
    }
}

export const OptionalLink = (props : {children : any, to? : string, className? : string, game? : CasinoGameInfo, onClick?: (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void}) => {
    if(typeof(props.game?.id) != "undefined") {
        return <Link to={toLaunchUrl(props.game.id, props.game.name)} className={props.className} onClick={props.onClick}>{props.children}</Link>
    } else if(!props.to) {
        return <div className={props.className}>{props.children}</div>
    } else {
        return <InternalLink to={props.to} className={props.className}>{props.children}</InternalLink>
    }
}
export const InternalLink = (props : {children : any, to : string, className? : string}) => {
    const dispatch = useDispatch();

    if(props.to == "/deposit") {
        return <a className={props.className} onClick={()=>dispatch(showCashier(true))}>{props.children}</a>;
    }
    if(props.to == "/buy-crypto") {
        return <a className={props.className} onClick={()=>dispatch(showCashier(true, CashierSection.BUY_CRYPTO))}>{props.children}</a>;
    }
    if(props.to == "/withdraw") {
        return <a className={props.className} onClick={()=>dispatch(showCashier(true, CashierSection.WITHDRAW))}>{props.children}</a>;
    }
    if(props.to == "/support") {
        return <a className={props.className} onClick={()=>openFreshChat()}>{props.children}</a>;
    }
    if(props.to === "/app-install") {
        return <a className={props.className} onClick={() => onAppInstall(dispatch)}>{props.children}</a>
    }

    // Solution for the new modal system, instead of rewriting current content in contentful.
    if(props.to.startsWith?.("/")) {
        let isModal = false
        let path
        if(props.to.includes("playnow")){
            if(props.to.includes("register")){
                isModal = true
                path = new URLSearchParams({type: PATH.REGISTRATION, modal: PATH.MODAL_TYPE}).toString()
            } else {
                isModal = true
                path = new URLSearchParams({type: PATH.LOGIN, modal: PATH.MODAL_TYPE}).toString()
            }
        }
        return <Link className={props.className} to={isModal ? {search: path } : props.to}>{props.children}</Link>
    }
    return <a className={props.className}  href={props.to?? "#"}>{props.children}</a>;
}
export const richTextOptions = {
    renderNode: {
        [BLOCKS.PARAGRAPH]: (node: any, next: any) => {
            return <span>{next}</span>
        },
        [INLINES.HYPERLINK] : (node : any, children : any) => {
            let dispatch = useDispatch();
            if(node?.data?.uri == "/deposit") {
                return <a onClick={()=>dispatch(showCashier(true))}>{children}</a>;
            }
            if(node?.data?.uri == "/buy-crypto") {
                return <a onClick={()=>dispatch(showCashier(true, CashierSection.BUY_CRYPTO))}>{children}</a>;
            }
            if(node?.data?.uri == "/withdraw") {
                return <a onClick={()=>dispatch(showCashier(true, CashierSection.WITHDRAW))}>{children}</a>;
            }
            if(node?.data?.uri == "/support") {
                return <a onClick={()=>openFreshChat()}>{children}</a>;
            }
            if(node?.data?.uri == "/app-install") {
                return <a onClick={() => onAppInstall(dispatch)}>{children}</a>;
            }
            if(node?.data?.uri?.startsWith?.("/")) {
                let isModal = false
                let path
                if(node.data.uri.includes("playnow")){
                    if(node.data.uri.includes("register")){
                        isModal = true
                        path = new URLSearchParams({type: PATH.REGISTRATION, modal: PATH.MODAL_TYPE}).toString()
                    } else {
                        isModal = true
                        path = new URLSearchParams({type: PATH.LOGIN, modal: PATH.MODAL_TYPE}).toString()
                    }
                }
                return <Link to={isModal ? {search: path } : node.data.uri}>{children}</Link>
            }
            return <a href={node?.data?.uri ?? "#"}>{children}</a>;
        },
        [BLOCKS.EMBEDDED_ASSET]: (node: any) => {
            const {title, description, file} = node.data.target.fields;
            const mimeType = file.contentType;
            const mimeGroup = mimeType.split('/')[0];

            if (mimeGroup == 'image') {
                return <img title={title ? title : null} alt={description ? description : "info"} src={file.url} />;
            } else {
                return <span style={{backgroundColor: 'red', color: 'white'}}> {mimeType} embedded asset </span>;
            }

        }
    }
}
export const richTextOptionsSideMenu = {
    renderNode: {
        [BLOCKS.PARAGRAPH]: (node: any, next: any) => {
            return next
        }
    }
}
export const richTextOptionsMarquee = {
    renderNode: {
        [BLOCKS.PARAGRAPH]: (node: any, next: any) => {
            return <Marquee gradient={false} speed={50}>{next}</Marquee>
        }
    }
}
export const StyledTextComponent = (props : { st : StyledText, loggedIn?: boolean, isSideMenu?: boolean}) => {

    let st = props.st;
    let className = "tagline " + (st?.cssClassName ?? "");
    if(props.loggedIn === true && props.st.hideLoggedIn === true) {
        return <></>
    }
    if(props.loggedIn === false && props.st.hideLoggedOut === true) {
        return <></>
    }

    if(st?.textLink?.startsWith("/") && !props.isSideMenu) {
      return (
          <InternalLink to={st?.textLink} className={className}>
              {st.richText  && renderContentAsComponent(st.richText as any, richTextOptions)}
          </InternalLink>
      )
    } else if(st?.textLink && !props.isSideMenu)  {
        return (
            <a href={st.textLink} className={className}>
                {st.richText  && renderContentAsComponent(st.richText as any, richTextOptions)}
            </a>
        )
    } else if (st?.textLink?.startsWith("/") && props.isSideMenu) {
        return (
            <React.Fragment>{st.richText  && renderContentAsComponent(st.richText as any, richTextOptionsSideMenu)}</React.Fragment>
        )
    } else if (st?.textLink && props.isSideMenu) {
        return (
            <React.Fragment>{st.richText  && renderContentAsComponent(st.richText as any, richTextOptionsSideMenu)}</React.Fragment>
        )
    } else if (st.horizontalScrollingText) {
        return (
            <div className={className}>
                {st.richText  && renderContentAsComponent(st.richText as any, richTextOptionsMarquee)}
            </div>
        )
    }
    if(st.html && st.html.length > 0) {
       return (
           <div className={className} dangerouslySetInnerHTML={{__html : st.html}}></div>
       )
    }
    return (
        <div className={className}>
            {st.richText  && renderContentAsComponent(st.richText as any, richTextOptions)}
        </div>
    )
    
}
export const HeroBannerTwoColumnsComponent = (props : Props) => {


    return (
        <>

            <div className={`${props.isFooter ? `footer-dynamic` : `hero-banner-two-columns`} ${(props.section?.cssClassName ?? "")} ${(props.section.topOfPage ? "top-of-page" : "")}`} style={toStyleBackground(props.section.backgroundImage)}>
               <div className={"container"}>
                   <div className={"row"}>
                       <div className={"col-md-6 taglines"}>
                           {props.section?.styledTexts?.map((s : StyledText, idx) => (
                                <StyledTextComponent st={s} key={idx} loggedIn={props.loggedIn}/>
                           ))}
                       </div>
                       <div className={"col-md-6"}>
                           {props.section.image?.fields?.file?.url && <img className="hero-banner-image" src={props.section.image?.fields.file?.url} />}
                       </div>
                       {props.section.styledTextList &&
                            <div className={"col-md-12 taglines-group"}>
                            {props.section.styledTextList?.map((styleList, idx) => {
                                return <div key={idx} className={`group ${styleList?.cssClassName ? styleList?.cssClassName : ''}`}>
                                    {styleList?.styledTexts?.filter(s => !!s).map((s : StyledText|StyledTextVideo) => {
                                        if((s as StyledTextVideo).video) {
                                            return <StyledTextVideoComponent video={s as StyledTextVideo}/>
                                        }
                                        return (
                                            <StyledTextComponent st={s} key={s._id} loggedIn={props.loggedIn}/>
                                        )

                                    })}
                                </div>
                            })}
                        </div>
                       }
                   </div>
               </div>
            </div>
        </>
    )
}

export const toStyleBackground = ( image?  : ImageObject) => {
    if(image?.fields?.file?.url) {
        return {backgroundImage  : ` url(${image.fields.file.url})`};
    }
    return {};
}

